<!--
 * @Author: 李朋飞
 * @Date: 2021-11-30 10:15:33
 * @LastEditTime: 2021-12-30 15:54:10
 * @Description: 公共的表单组件
-->
<template>
  <el-form
    :label-width="labelWidth"
    :label-position="labelPosition"
    :inline="inline"
    :model="formKeyList"
    ref="formPanelRef"
    :class="`l_form ${themeColor == 'yellow' ? 'l_form_yellow' : ''}`">
    <el-row>
      <el-col
        :span="24 / Number(cols)"
        v-for="(item, index) in formConfig"
        :key="index"
      >
      <!-- input类型 -->
        <el-form-item
          v-if="item.type === 'input'"
          :label="item.label"
          :prop="item.fieldName"
          :rules="item.rules ? item.rules : []"
        >
          <div :style="item.style ? item.style : ''"  :class="`l_form_input ${item.insertLeft ? 'l_form_input_insertLeft' : ''} ${item.insertRight ? 'l_form_input_insertRight' : ''}`">
            <el-input
              :clearable="clearable"
              :style="item.style ? item.style : ''"
              v-model.trim="formKeyList[item.fieldName]"
              :disabled="item.disabled ? item.disabled : false"
              @change="item.change"
              :placeholder="item.placeholder ? item.placeholder : `请输入`">
            </el-input>
            <span class="l_form_input_left" v-if="item.insertLeft">{{item.insertLeft}}</span>
            <span class="l_form_input_right" v-if="item.insertRight">{{item.insertRight}}</span>
          </div>
        </el-form-item>
        <!-- 数字类型Input -->
        <el-form-item
          v-if="item.type === 'inputNumber'"
          :label="item.label"
          :prop="item.fieldName"
          :rules="item.rules ? item.rules : []"
        >
          <div :style="item.style ? item.style : ''"  :class="`l_form_input ${item.insertLeft ? 'l_form_input_insertLeft' : ''} ${item.insertRight ? 'l_form_input_insertRight' : ''}`">
            <el-input
              @keydown.native="inputKeydown($event, item.DisableInput)"
              type="Number"
              :clearable="clearable"
              :style="item.style ? item.style : ''"
              v-model="formKeyList[item.fieldName]"
              :disabled="item.disabled ? item.disabled : false"
              @change="item.change"
              :placeholder="item.placeholder ? item.placeholder : `请输入`">
            </el-input>
            <span class="l_form_input_left" v-if="item.insertLeft">{{item.insertLeft}}</span>
            <span class="l_form_input_right" v-if="item.insertRight">{{item.insertRight}}</span>
          </div>
        </el-form-item>
      <!-- 范围输入框 -->
        <el-form-item
          v-if="item.type === 'inputrange'"
          :label="item.label"
          :required="item.rules ? true : false"
        >
          <el-col :span="10">
            <el-form-item
              :prop="item.fieldName[0]"
              :rules="item.rules ? item.rules : []"
            >
              <el-input
                :clearable="clearable"
                :style="item.style ? item.style : ''"
                v-model="formKeyList[item.fieldName[0]]"
                :disabled="item.disabled ? item.disabled : false"
                :placeholder="item.placeholder[0] ? item.placeholder[0] : `请输入`"
                @change="inputrangeStarChange($event, item.fieldName[0],item.fieldName[1])"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col style="text-align: center;" :span="4">{{item.rangeSeparator}}</el-col>
          <el-col :span="10">
            <el-form-item
              :prop="item.fieldName[1]"
              :rules="item.rules ? item.rules : []"
            >
              <el-input
                :clearable="clearable"
                :style="item.style ? item.style : ''"
                v-model="formKeyList[item.fieldName[1]]"
                :disabled="item.disabled ? item.disabled : false"
                :placeholder="item.placeholder[1] ? item.placeholder[1] : `请输入`"
                @change="inputrangeEndChange($event, item.fieldName[0],item.fieldName[1])"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
      <!-- select类型 -->
        <el-form-item
          v-if="item.type === 'select'"
          :label="item.label"
          :prop="item.fieldName"
          :rules="item.rules ? item.rules : []"
        >
          <el-select
            filterable
            :style="item.style ? item.style : ''"
            :clearable="clearable"
            v-model="formKeyList[item.fieldName]"
            :disabled="item.disabled ? item.disabled : false"
            @change="item.change"
            :placeholder="item.placeholder ? item.placeholder : `请选择`"
          >
            <el-option
              v-for="(selectItem, selectIndex) in item.itemList"
              :key="selectIndex"
              :label="selectItem.label"
              :value="selectItem">
            </el-option>
          </el-select>
        </el-form-item>
      <!-- 日期选择data-->
        <el-form-item
          v-if="item.type === 'date'"
          :label="item.label"
          :prop="item.fieldName"
          :rules="item.rules ? item.rules : []"
        >
          <el-date-picker
            :value-format="item.valueFormat ? item.valueFormat :' yyyy-MM-dd'"
            :style="item.style ? item.style : ''"
            :clearable="clearable"
            v-model="formKeyList[item.fieldName]"
            :type="item.dataType ? item.dataType : 'date'"
            :placeholder="item.placeholder ? item.placeholder : `请选择`"
            :range-separator="item.rangeSeparator ? item.rangeSeparator : ''"
            :start-placeholder="item.starPlaceholder ? item.starPlaceholder : ''"
            :end-placeholder="item.endPlaceholder ? item.endPlaceholder : ''"
            :disabled="item.disabled ? item.disabled : false"
            @change="item.change"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 日期段选择daterange -->
        <el-form-item
          v-if="item.type === 'daterange'"
          :label="item.label"
          :required="item.rules ? true : false"
        >
          <el-col :span="11">
            <el-form-item
              :prop="item.fieldName[0]"
              :rules="item.rules ? item.rules : []"
            >
              <el-date-picker
                :type="item.dataType ? item.dataType : 'date'"
                :value-format="item.valueFormat ? item.valueFormat :'yyyy-MM-dd'"
                :format="item.valueFormat ? item.valueFormat :'yyyy-MM-dd'"
                :style="item.style ? item.style : ''"
                :clearable="clearable"
                v-model="formKeyList[item.fieldName[0]]"
                :disabled="item.disabled ? item.disabled : false"
                @change="item.change"
                :placeholder="item.placeholder[0] ? item.placeholder[0] : `请选择`"
                :picker-options="pickerOptionsStar(item.fieldName[1])"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col style="text-align: center;" :span="2">{{item.rangeSeparator}}</el-col>
          <el-col :span="11">
            <el-form-item
              :prop="item.fieldName[1]"
              :rules="item.rules ? item.rules : []"
            >
              <el-date-picker
                :type="item.dataType ? item.dataType : 'date'"
                :value-format="item.valueFormat ? item.valueFormat :'yyyy-MM-dd'"
                :format="item.valueFormat ? item.valueFormat :'yyyy-MM-dd'"
                :style="item.style ? item.style : ''"
                :clearable="clearable"
                v-model="formKeyList[item.fieldName[1]]"
                :disabled="item.disabled ? item.disabled : false"
                @change="item.change"
                :placeholder="item.placeholder[1] ? item.placeholder[1] : `请选择`"
                :picker-options="pickerOptionsEnd(item.fieldName[0])"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
      <!-- switch -->
        <el-form-item
          v-if="item.type === 'switch'"
          :label="item.label"
          :prop="item.fieldName"
          :rules="item.rules ? item.rules : []"
        >
          <el-switch
            :clearable="clearable"
            :style="item.style ? item.style : ''"
            v-model="formKeyList[item.fieldName]"
            :active-value="item.activeValue ? item.activeValue : true"
            :inactive-value="item.inactiveValue ? item.inactiveValue : false"
            :active-color="themeColor == 'yellow' ? '#FFC700' : '#409EFF'"
            :inactive-colo="item.inactiveColor ? item.inactiveColor : '#C0CCDA'"
            :placeholder="item.placeholder ? item.placeholder : `请输入`"
            :disabled="item.disabled ? item.disabled : false"
            @change="item.change"
          >
          </el-switch>
        </el-form-item>
      <!-- 单选框 -->
        <el-form-item
          v-if="item.type === 'radio'"
          :label="item.label"
          :prop="item.fieldName"
          :rules="item.rules ? item.rules : []"
        >
          <el-radio-group
            v-model="formKeyList[item.fieldName]"
            @change="item.change"
            :disabled="item.disabled ? item.disabled : false"
          >
            <el-radio
              v-for="(checkboxItem, checkboxINdex) in item.itemList"
              :label="checkboxItem"
              :key="checkboxINdex"
            >
              {{checkboxItem.label}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
      <!-- 多选框 -->
        <el-form-item
          v-if="item.type === 'checkbox' && formKeyList[item.fieldName]"
          :label="item.label"
          :prop="item.fieldName"
          :rules="item.rules ? item.rules : []"
        >
          <el-checkbox-group
            v-model="formKeyList[item.fieldName]"
            @change="item.change"
            :disabled="item.disabled ? item.disabled : false"
          >
            <el-checkbox
              v-for="(checkboxItem, checkboxINdex) in item.itemList"
              :label="checkboxItem"
              :key="checkboxINdex">
              {{checkboxItem.label}}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      <!-- 文本框 -->
        <el-form-item
          v-if="item.type === 'textarea'"
          :label="item.label"
          :prop="item.fieldName"
          :rules="item.rules ? item.rules : []"
        >
          <el-input
            type="textarea"
            :clearable="clearable"
            :rows="item.rows ? item.rows : 2"
            :style="item.style ? item.style : ''"
            v-model="formKeyList[item.fieldName]"
            :disabled="item.disabled ? item.disabled : false"
            @change="item.change"
            :maxlength="item.maxlength ? item.maxlength : ''"
            show-word-limit
            :placeholder="item.placeholder ? item.placeholder : `请输入`">
          </el-input>
        </el-form-item>
      <!-- 上传控件 -->
        <el-form-item
          v-if="item.type === 'uploadFile' || item.type === 'uploadImg' || item.type === 'showFile'"
          :label="item.label"
          :prop="item.fieldName"
          :rules="item.rules ? item.rules : []"
        >
          <UploadFile
            :uploadType="item.type"
            :FileList="item.initValue"
            :maxLenght="item.maxLenght ? item.maxLenght : 10"
            :width="item.width ? item.width : '100px'"
            :height="item.height ? item.height : '100px'"
            :fontSize="item.fontSize ? item.fontSize : '14px'"
            :iconColor="item.iconColor ? item.iconColor : (themeColor == 'yellow' ? '#FFC700' : '#409EFF')"
          />
        </el-form-item>
        <!-- 仅展示 -->
        <el-form-item
          v-if="item.type === 'show'"
          :label="item.label"
          class="l_formPanel_show"
          style="margin-bottom:10px"
        >
          <div style="display: flex;">
            <div style="font-size:12px; line-height: 20px" v-if="formKeyList[item.fieldName]" v-html="formKeyList[item.fieldName].replace(/\n/g,'</br>')"></div>
            <el-button type="primary" size="mini" v-if="item.canCopy" style="margin-left: 4px;" @click="copy(item)">复制</el-button>
          </div>
        </el-form-item>
      </el-col>
      <el-col v-if="isSubmitBtn" :span="(formConfig.length % Number(cols) === 0 || !inline) ? 24 : ((Number(cols) - formConfig.length%Number(cols)) * (24 / Number(cols))) ">
        <div class="l_form_footer_right" v-if="inline">
          <el-button class="l_form_footer_right_subBtn" @click="onSubmit">{{submitBtnText}}</el-button>
          <el-button class="l_form_footer_right_closeBtn" @click="resetForm">{{closeBtnText}}</el-button>
        </div>
        <div class="l_form_footer_center" v-else>
          <el-button class="l_form_footer_right_subBtn" @click="onSubmit">{{submitBtnText}}</el-button>
          <el-button class="l_form_footer_right_closeBtn" @click="resetForm">{{closeBtnText}}</el-button>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  name: '',
  props: {
    formConfig: { // 表单的渲染数据，必须
      type: Array,
      required: true,
    },
    themeColor: {
      type: String,
      default: 'blue'
    },
    cols: { // 每一行显示数量，必须可以被24整除
      type: Number,
      default: 2
    },
    clearable: { // 是否可清空
      type: Boolean,
      default: true
    },
    labelWidth: { // title容器的宽度
      type: String,
      default: '120px'
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    inline: { // 是否启用行内表单
      type: Boolean,
      default: false
    },
    isSubmitBtn: { // 是否显示查询重置按钮
      type: Boolean,
      default: true
    },
    submitBtnText: {
      type: String,
      default: '查询'
    },
    closeBtnText: {
      type: String,
      default: '重置'
    },
  },
  data() {
    return{
      formKeyList: {}, // 表单每一项绑定key值的对象
    }
  },
  mounted() {
    this.createFormkey();
  },
  watch: {
    formConfig: {
      handler(newValue, oldValue) {
        newValue.forEach(item => {
          if(!item.change) { // 手动给数据添加默认事件
            item.change = () => {};
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    copy(item) {
      navigator.clipboard.writeText(item.initValue).then(() => {
        this.$message({ type: 'success', message: '复制成功', });
      }).catch((error) => {
        this.$message({ type: 'warning', message: `复制文本到剪贴板时发生错误:${error}`, });
      });
    },
    createFormkey() { // 创建表单Key的集合
      let arr = {};
      this.formConfig.forEach(item => {
        if(typeof item.fieldName == 'string') {
          arr[item.fieldName] = item.initValue ? item.initValue : '';
        } else { // 处理范围输入的key
          arr[item.fieldName[0]] = item.initValue[0] ? item.initValue[0] : '';
          arr[item.fieldName[1]] = item.initValue[1] ? item.initValue[1] : '';
        }
      });
      this.formKeyList = arr;
    },
    onSubmit() { // 提交
      this.$refs.formPanelRef.validate((valid) => {
        if (valid) {
          this.$emit('formChange', this.formKeyList);
        } else {
          return false;
        }
      });
    },
    FormPanelValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.formPanelRef.validate((valid) => {
          if(valid) {
            let formData = JSON.parse(JSON.stringify(this.formKeyList))
            resolve(formData);
          } else {
            return false;
          }
        })
      })
    },
    inputKeydown(e, DisableInput) { // 禁止输入不合法字符
      let key = e.key;
      let DisableInputStr = '';
      if(DisableInput){
        DisableInputStr = DisableInput;
      } else {
        DisableInputStr = 'e,+,-,Shift'
      }
      if(DisableInputStr.indexOf(key) > -1) {
        e.returnValue = false;
        return false
      };
      return true;
    },
    inputrangeStarChange(e, skey, eKey){ // 范围查询输入框初始值
      if(this.formKeyList[eKey] && Number(this.formKeyList[eKey]) <= Number(e)) {
        if(this.formKeyList[eKey] > 1) {
          this.formKeyList[skey] = Number(this.formKeyList[eKey])  - 1;
        } else {
          this.formKeyList[skey] = 0;
        }
      }
    },
    inputrangeEndChange(e, skey, eKey){ // 范围查询输入框结束
      if(this.formKeyList[skey] && Number(this.formKeyList[skey]) >= Number(e)) {
        this.formKeyList[eKey] = Number(this.formKeyList[skey])  + 1;
      }
    },
    pickerOptionsStar(key) { // 范围日期禁用
      let that = this;
      return {
        disabledDate(time) {
          if(that.formKeyList[key]) {
            return time.getTime() > (new Date(that.formKeyList[key])).getTime();
          }
        },
      }
    },
    pickerOptionsEnd(key) { // 范围日期禁用
      let that = this;
      return {
        disabledDate(time) {
          if(that.formKeyList[key] && that.formKeyList[key] != '') {
            return time.getTime() < (new Date(that.formKeyList[key])).getTime();
          }
        },
      }
    },
    resetForm() {
      this.createFormkey();
      this.$nextTick(() => {
        this.$refs.formPanelRef.clearValidate();
      });
      this.$emit('resetFormChange', this.formKeyList);
    },
  }
}
</script>
<style lang='scss' scoped>
.l_form{
  width: 100%;
  overflow: hidden;
  /deep/ .el-form-item{
    display: flex;
    margin-right: 0px;
    .el-form-item__label{
      font-size: 12px !important;
    }
    .el-form-item__content{
      flex: 1;
      width: auto !important;
      margin: 0 !important;
    }
  }
  /deep/ .l_formPanel_show{
    .el-form-item__label{
      font-size: 12px !important;
      line-height: 20px !important;
    }
  }
  /deep/ .el-select{
    width: 100% !important;
  }
  /deep/ .el-date-editor{
    width: 100% !important;
  }
  .l_form_footer_right{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
    .l_form_footer_right_subBtn{
      background-color: #409EFF;
      border: #409EFF 1px solid;
      color: #FFF;
    }
    .l_form_footer_right_closeBtn{
      background-color: #E6E6E6;
      border: #E6E6E6 1px solid;
      color: #606266;
    }
    /deep/ .el-button{
      min-width: 90px !important;
    }
  }
  .l_form_footer_center{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    /deep/ .el-button{
      min-width: 90px !important;
      margin-right: 20px;
    }
  }
}
.l_form_yellow{
  /deep/ .el-input__inner:focus{
    border-color:#FFC700 !important;
  }
  /deep/ .el-textarea__inner:focus{
    border-color:#FFC700 !important;
  }
  .l_form_footer_right_subBtn{
    background-color: #FFC700 !important;
    border: #FFC700 1px solid !important;
    color: #333333 !important;
  }
  /deep/ .el-range-editor.is-active, .el-range-editor.is-active:hover{
    border-color: #FFC700 !important;
  }
  /deep/ .el-radio__input.is-checked .el-radio__inner{
    background-color: #FFC700 !important;
    border: #FFC700 1px solid !important;
  }
  /deep/ .el-radio__input.is-checked+.el-radio__label{
    color: #FFC700;
  }
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #FFC700 !important;
    border: #FFC700 1px solid !important;
  }
  /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #FFC700;
  }
  /deep/ .el-checkbox__input.is-focus .el-checkbox__inner{
    border: #FFC700 1px solid !important;
  }
}
.l_form_input{
  position: relative;
  .l_form_input_left{
    position: absolute;
    left: 10px;
    color: #999999;
    font-size: 14px;
  }
  .l_form_input_right{
    position: absolute;
    right: 30px;
    color: #999999;
    font-size: 14px;
  }
}
.l_form_input_insertLeft{
  /deep/ input{
    padding-left: 30px;
  }
}
.l_form_input_insertRight{
  /deep/ input{
    padding-right: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FormPanel/FormPanel.vue